import React, { createContext, useContext, useMemo, useEffect, useState } from "react";
import { useUser } from "@clerk/clerk-react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { isSignedIn: clerkSignedIn, isLoaded } = useUser(); 
  const [isSignedIn, setIsSignedIn] = useState(() => {
    const savedSignInState = localStorage.getItem("isSignedIn");
    return savedSignInState ? JSON.parse(savedSignInState) : undefined;
  });

  useEffect(() => {
    if (isLoaded) {
      setIsSignedIn(clerkSignedIn);
      localStorage.setItem("isSignedIn", JSON.stringify(clerkSignedIn));
    }
  }, [clerkSignedIn, isLoaded]);

  const role = localStorage.getItem("role");
  const auth = localStorage.getItem("authorization");

  const value = useMemo(() => ({
    isSignedIn,
    isLoaded,
    role, 
    authorization: auth 
  }), [isSignedIn, isLoaded, role, auth]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUserContext = () => {
  return useContext(UserContext);
};
